import { getLevelArrayMetric as r } from "../index4.js";
import { getLevelGIA as t } from "../level-metrics/index20.js";
const A = (e) => r(e, t);
export {
  A as getLevelArrayGIA
};
//# sourceMappingURL=index9.js.map
